const IMAGE_HOST = import.meta.env.VITE_IMAGE_RESIZER_HOST

export type ImageResizerProps = {
  bucket?: string
  key?: string
  edits?: Edits
}

export type Edits = {
  resize?: Resize
  flatten?: Flatten | boolean
  grayscale?: boolean
  flip?: boolean
  flop?: boolean
  negate?: boolean
  normalise?: boolean
  smartCrop?: SmartCrop
  tint?: Background
}

export type Resize = {
  height?: number
  width?: number
  fit?: 'cover' | 'contain' | 'fill' | 'inside' | 'outside'
  background?: Background
}

export type Background = {
  r?: number
  g?: number
  b?: number
  alpha?: number | null
}

export type SmartCrop = {
  faceIndex?: number
  padding?: number
}

export type Flatten = {
  background?: Background
}

export const imageResizer = ({ bucket, key, edits }: ImageResizerProps): string => {
  if (!bucket || !key) return ''

  const imageRequest = JSON.stringify({
    bucket,
    key,
    edits,
  })

  const encodedJson = btoa(imageRequest)
  return `${IMAGE_HOST}/${encodedJson}`
}
